export const SET_CUSTOMER = 'companies/SET_CUSTOMER'; // this one used for creation
export const SET_CUSTOMER_ACTIVE = 'companies/SET_CUSTOMER_ACTIVE'; // this one on user edit page
export const SET_BILLING_ADDRESS = 'companies/SET_BILLING_ADDRESS';
export const SET_ADMIN_USER = 'companies/SET_ADMIN_USER';
export const CHANGE_STEP = 'companies/CHANGE_STEP';

export const CREATE_CUSTOMER = 'companies/CREATE_CUSTOMER';

export const SELECT_CUSTOMER = 'companies/SELECT_CUSTOMER';

export const GET_ORGANIZATION_WITH_CUSTOMERS = 'companies/GET_ORGANIZATION_WITH_CUSTOMERS';
export const GET_CUSTOMERS = 'companies/GET_CUSTOMERS';
export const GET_CUSTOMER_USERS = 'companies/GET_CUSTOMER_USERS';
export const GET_CUSTOMER_USERS_ROLES = 'companies/GET_CUSTOMER_USERS_ROLES';

export const SET_ACCOUNT_MANAGER = 'companies/SET_ACCOUNT_MANAGER';
export const SET_ACCOUNT_REPRESENTATIVE = 'companies/SET_ACCOUNT_REPRESENTATIVE';
export const REMOVE_USER = 'companies/REMOVE_USER';
export const GET_CUSTOMER_LICENSES = 'companies/GET_LICENSES';
export const GET_CUSTOMER_ACCOUNT_REPRESENTATIVES = 'companies/GET_CUSTOMER_ACCOUNT_REPRESENTATIVES';
export const GET_CUSTOMER_APPLICATIONS = 'companies/GET_CUSTOMER_APPLICATIONS';

// External users management
export const REMOVE_SELECTED_USER = 'companies/REMOVE_SELECTED_USER';
export const SELECT_USER = 'companies/SELECT_USER';
export const REMOVE_ALL_SELECTED_USERS = 'companies/REMOVE_ALL_SELECTED_USERS';
